import RInput from '../form/Input';
import { fetchDataFromSiret } from '../../api/tabsApi';

const RSiret = (props: any) => {
  const { handleOnChange, f, setFormData } = props as any;

  const handleChange = async (label: string, e: any, forced?: boolean) => {
    handleOnChange(label, e, forced);

    if (!e) return;

    const resp = await fetchDataFromSiret(e);
    const address = resp?.address;
    const company_name = resp?.company_name;
    const addressLinked = f.addressLinked;
    const companyLinked = f.companyLinked;

    if (!address || !addressLinked || !companyLinked) return;

    setFormData((fd: any) => ({
      ...fd,
      [`${addressLinked}_street`]: address.street,
      [`${addressLinked}_city`]: address.locality,
      [`${addressLinked}_dept`]: address.administrative_area_level_2,
      [`${addressLinked}_postal`]: address.postal_code,
      [`${addressLinked}`]: address.place_id,
      [`${addressLinked}_addressDescription`]: address.description,
      [companyLinked]: company_name,
    }));
  };

  return (
    <>
      <RInput
        {...props}
        f={{ ...f, type: 'number' }}
        handleOnChange={handleChange}
      />
    </>
  );
};

export default RSiret;
